import { Union } from "./.fable/fable-library.3.2.9/Types.js";
import { TokenAssoc, format_token, token_prec, token_assoc, TokenArity, token_arity, Token$reflection } from "./Lexer.fs.js";
import { union_type } from "./.fable/fable-library.3.2.9/Reflection.js";
import { empty, cons, head, tail, isEmpty } from "./.fable/fable-library.3.2.9/List.js";
import { equals } from "./.fable/fable-library.3.2.9/Util.js";
import { printf, toText } from "./.fable/fable-library.3.2.9/String.js";

export class Node$ extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UnaryNode", "BinaryNode", "AtomNode"];
    }
}

export function Node$$reflection() {
    return union_type("Parser.Node", [], Node$, () => [[["Item1", Token$reflection()], ["Item2", Node$$reflection()]], [["Item1", Token$reflection()], ["Item2", Node$$reflection()], ["Item3", Node$$reflection()]], [["Item", Token$reflection()]]]);
}

export function parse_helper(stack_mut, op_stack_mut, token_stream_mut) {
    let op_t, op_op, op_t_2, op_op_2, op_t_7, op_op_6, op_t_5, op_op_4, op_t_11, op_op_10, op_t_9, op_op_8;
    parse_helper:
    while (true) {
        const stack = stack_mut, op_stack = op_stack_mut, token_stream = token_stream_mut;
        if (!isEmpty(token_stream)) {
            const t_1 = tail(token_stream);
            const op_1 = head(token_stream);
            switch (op_1.tag) {
                case 2: {
                    const v = op_1.fields[0];
                    stack_mut = cons(new Node$(2, op_1), stack);
                    op_stack_mut = op_stack;
                    token_stream_mut = t_1;
                    continue parse_helper;
                }
                case 0: {
                    stack_mut = stack;
                    op_stack_mut = cons(op_1, op_stack);
                    token_stream_mut = t_1;
                    continue parse_helper;
                }
                case 1: {
                    if (!isEmpty(op_stack)) {
                        if ((op_t = tail(op_stack), (op_op = head(op_stack), equals(token_arity(op_op), new TokenArity(0))))) {
                            const op_op_1 = head(op_stack);
                            const op_t_1 = tail(op_stack);
                            const operand_1 = head(stack);
                            stack_mut = cons(new Node$(0, op_op_1, operand_1), tail(stack));
                            op_stack_mut = op_t_1;
                            token_stream_mut = cons(op_1, t_1);
                            continue parse_helper;
                        }
                        else {
                            let pattern_matching_result, op_op_3, op_t_3;
                            if (!isEmpty(op_stack)) {
                                if ((op_t_2 = tail(op_stack), (op_op_2 = head(op_stack), equals(token_arity(op_op_2), new TokenArity(1))))) {
                                    pattern_matching_result = 0;
                                    op_op_3 = head(op_stack);
                                    op_t_3 = tail(op_stack);
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                            switch (pattern_matching_result) {
                                case 0: {
                                    const right_1 = head(stack);
                                    const left_1 = head(tail(stack));
                                    stack_mut = cons(new Node$(1, op_op_3, left_1, right_1), tail(tail(stack)));
                                    op_stack_mut = op_t_3;
                                    token_stream_mut = cons(op_1, t_1);
                                    continue parse_helper;
                                }
                                case 1: {
                                    let pattern_matching_result_1, op_t_4;
                                    if (!isEmpty(op_stack)) {
                                        if (head(op_stack).tag === 0) {
                                            pattern_matching_result_1 = 0;
                                            op_t_4 = tail(op_stack);
                                        }
                                        else {
                                            pattern_matching_result_1 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_1 = 1;
                                    }
                                    switch (pattern_matching_result_1) {
                                        case 0: {
                                            stack_mut = stack;
                                            op_stack_mut = op_t_4;
                                            token_stream_mut = t_1;
                                            continue parse_helper;
                                        }
                                        case 1: {
                                            throw (new Error("unexpected )"));
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        throw (new Error("unexpected )"));
                    }
                }
                default: {
                    const matchValue_1 = token_assoc(op_1);
                    switch (matchValue_1.tag) {
                        case 0: {
                            let pattern_matching_result_2, op_op_5, op_t_6;
                            if (!isEmpty(op_stack)) {
                                if ((op_t_5 = tail(op_stack), (op_op_4 = head(op_stack), token_prec(op_1) <= token_prec(op_op_4)))) {
                                    pattern_matching_result_2 = 0;
                                    op_op_5 = head(op_stack);
                                    op_t_6 = tail(op_stack);
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                            switch (pattern_matching_result_2) {
                                case 0: {
                                    const matchValue_2 = token_arity(op_op_5);
                                    switch (matchValue_2.tag) {
                                        case 1: {
                                            const right_2 = head(stack);
                                            const left_2 = head(tail(stack));
                                            stack_mut = cons(new Node$(1, op_op_5, left_2, right_2), tail(tail(stack)));
                                            op_stack_mut = op_t_6;
                                            token_stream_mut = cons(op_1, t_1);
                                            continue parse_helper;
                                        }
                                        case 2: {
                                            throw (new Error("unexpected token"));
                                        }
                                        default: {
                                            const operand_2 = head(stack);
                                            stack_mut = cons(new Node$(0, op_op_5, operand_2), tail(stack));
                                            op_stack_mut = op_t_6;
                                            token_stream_mut = cons(op_1, t_1);
                                            continue parse_helper;
                                        }
                                    }
                                }
                                case 1: {
                                    let pattern_matching_result_3;
                                    if (isEmpty(op_stack)) {
                                        pattern_matching_result_3 = 0;
                                    }
                                    else if (head(op_stack).tag === 0) {
                                        pattern_matching_result_3 = 0;
                                    }
                                    else if ((op_t_7 = tail(op_stack), (op_op_6 = head(op_stack), token_prec(op_1) > token_prec(op_op_6)))) {
                                        pattern_matching_result_3 = 1;
                                    }
                                    else {
                                        pattern_matching_result_3 = 2;
                                    }
                                    switch (pattern_matching_result_3) {
                                        case 0: {
                                            stack_mut = stack;
                                            op_stack_mut = cons(op_1, op_stack);
                                            token_stream_mut = t_1;
                                            continue parse_helper;
                                        }
                                        case 1: {
                                            stack_mut = stack;
                                            op_stack_mut = cons(op_1, op_stack);
                                            token_stream_mut = t_1;
                                            continue parse_helper;
                                        }
                                        case 2: {
                                            throw (new Error("unexpected operator"));
                                        }
                                    }
                                }
                            }
                        }
                        case 1: {
                            let pattern_matching_result_4, op_op_9, op_t_10;
                            if (!isEmpty(op_stack)) {
                                if ((op_t_9 = tail(op_stack), (op_op_8 = head(op_stack), token_prec(op_1) < token_prec(op_op_8)))) {
                                    pattern_matching_result_4 = 0;
                                    op_op_9 = head(op_stack);
                                    op_t_10 = tail(op_stack);
                                }
                                else {
                                    pattern_matching_result_4 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_4 = 1;
                            }
                            switch (pattern_matching_result_4) {
                                case 0: {
                                    const matchValue_3 = token_arity(op_op_9);
                                    switch (matchValue_3.tag) {
                                        case 0: {
                                            const operand_3 = head(stack);
                                            stack_mut = cons(new Node$(0, op_op_9, operand_3), tail(stack));
                                            op_stack_mut = op_t_10;
                                            token_stream_mut = cons(op_1, t_1);
                                            continue parse_helper;
                                        }
                                        case 1: {
                                            const right_3 = head(stack);
                                            const left_3 = head(tail(stack));
                                            stack_mut = cons(new Node$(1, op_op_9, left_3, right_3), tail(tail(stack)));
                                            op_stack_mut = op_t_10;
                                            token_stream_mut = cons(op_1, t_1);
                                            continue parse_helper;
                                        }
                                        default: {
                                            throw (new Error("unexpected token"));
                                        }
                                    }
                                }
                                case 1: {
                                    let pattern_matching_result_5;
                                    if (isEmpty(op_stack)) {
                                        pattern_matching_result_5 = 0;
                                    }
                                    else if (head(op_stack).tag === 0) {
                                        pattern_matching_result_5 = 0;
                                    }
                                    else if ((op_t_11 = tail(op_stack), (op_op_10 = head(op_stack), token_prec(op_1) >= token_prec(op_op_10)))) {
                                        pattern_matching_result_5 = 1;
                                    }
                                    else {
                                        pattern_matching_result_5 = 2;
                                    }
                                    switch (pattern_matching_result_5) {
                                        case 0: {
                                            stack_mut = stack;
                                            op_stack_mut = cons(op_1, op_stack);
                                            token_stream_mut = t_1;
                                            continue parse_helper;
                                        }
                                        case 1: {
                                            stack_mut = stack;
                                            op_stack_mut = cons(op_1, op_stack);
                                            token_stream_mut = t_1;
                                            continue parse_helper;
                                        }
                                        case 2: {
                                            throw (new Error("unexpected operator"));
                                        }
                                    }
                                }
                            }
                        }
                        default: {
                            throw (new Error("unexpected operator"));
                        }
                    }
                }
            }
        }
        else if (!isEmpty(op_stack)) {
            const t = tail(op_stack);
            const op = head(op_stack);
            const matchValue = token_arity(op);
            switch (matchValue.tag) {
                case 1: {
                    const right = head(stack);
                    const left = head(tail(stack));
                    stack_mut = cons(new Node$(1, op, left, right), tail(tail(stack)));
                    op_stack_mut = t;
                    token_stream_mut = empty();
                    continue parse_helper;
                }
                case 2: {
                    throw (new Error("unexpected token"));
                }
                default: {
                    const operand = head(stack);
                    stack_mut = cons(new Node$(0, op, operand), tail(stack));
                    op_stack_mut = t;
                    token_stream_mut = empty();
                    continue parse_helper;
                }
            }
        }
        else {
            return head(stack);
        }
        break;
    }
}

export function parse(token_stream) {
    return parse_helper(empty(), empty(), token_stream);
}

export function node_prec(node) {
    let op_3;
    switch (node.tag) {
        case 1: {
            const op_1 = node.fields[0];
            op_3 = op_1;
            break;
        }
        case 2: {
            const op_2 = node.fields[0];
            op_3 = op_2;
            break;
        }
        default: {
            const op = node.fields[0];
            op_3 = op;
        }
    }
    return token_prec(op_3) | 0;
}

export function node_assoc(node) {
    let op_3;
    switch (node.tag) {
        case 1: {
            const op_1 = node.fields[0];
            op_3 = op_1;
            break;
        }
        case 2: {
            const op_2 = node.fields[0];
            op_3 = op_2;
            break;
        }
        default: {
            const op = node.fields[0];
            op_3 = op;
        }
    }
    return token_assoc(op_3);
}

export function node_print(node) {
    let op_prec_1, op_prec_2, operand, op, op_prec;
    const prec = node_prec(node) | 0;
    let pattern_matching_result, op_1, operand_1;
    if (node.tag === 0) {
        if ((operand = node.fields[1], (op = node.fields[0], (op_prec = (node_prec(operand) | 0), (prec > op_prec) ? (op_prec > 0) : false)))) {
            pattern_matching_result = 0;
            op_1 = node.fields[0];
            operand_1 = node.fields[1];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const arg20 = node_print(operand_1);
            const arg10 = format_token(op_1);
            return toText(printf("%s(%s)"))(arg10)(arg20);
        }
        case 1: {
            switch (node.tag) {
                case 1: {
                    const right = node.fields[2];
                    const op_3 = node.fields[0];
                    const left = node.fields[1];
                    let ls;
                    if ((op_prec_1 = (node_prec(left) | 0), ((prec > op_prec_1) ? (op_prec_1 > 0) : false) ? true : ((prec === op_prec_1) ? equals(node_assoc(left), new TokenAssoc(1)) : false))) {
                        const arg10_2 = node_print(left);
                        ls = toText(printf("(%s)"))(arg10_2);
                    }
                    else {
                        ls = node_print(left);
                    }
                    let rs;
                    if ((op_prec_2 = (node_prec(right) | 0), ((prec > op_prec_2) ? (op_prec_2 > 0) : false) ? true : ((prec === op_prec_2) ? equals(node_assoc(right), new TokenAssoc(0)) : false))) {
                        const arg10_3 = node_print(right);
                        rs = toText(printf("(%s)"))(arg10_3);
                    }
                    else {
                        rs = node_print(right);
                    }
                    const arg20_2 = format_token(op_3);
                    return toText(printf("%s%s%s"))(ls)(arg20_2)(rs);
                }
                case 2: {
                    const op_4 = node.fields[0];
                    const arg10_5 = format_token(op_4);
                    return toText(printf("%s"))(arg10_5);
                }
                default: {
                    const operand_2 = node.fields[1];
                    const op_2 = node.fields[0];
                    const arg20_1 = node_print(operand_2);
                    const arg10_1 = format_token(op_2);
                    return toText(printf("%s%s"))(arg10_1)(arg20_1);
                }
            }
        }
    }
}

